<template>
  <Dialog v-model="isShowDialog" :persistent="persistent" :width="width" :height="height" :is-close-confirm="isCloseConfirm" @close="close">
    <template #dialog-title>
      <Label medium>
        <slot name="dialog-title"></slot>
      </Label>
    </template>

    <template #dialog-content>
      <v-layout
        row
        :style="{
          minHeight: contentMinHeight + 'px'
        }"
      >
        <v-layout align-start style="max-width: 60px" v-if="icon">
          <Icon :size="60" :color="color">error</Icon>
        </v-layout>
        <Label xsmall class="mt-1 ml-3 dialog-message" :class="messagePreWrap ? 'pre-wrap' : ''"><slot name="dialog-message"></slot></Label>
      </v-layout>
    </template>

    <template #dialog-action>
      <v-layout row align-center justify-end style="width: calc(width + px - 78px)">
        <slot name="dialog-action"></slot>
      </v-layout>
    </template>
  </Dialog>
</template>

<script>
import Label from '@/components/_atoms/labels/Label.vue';
import Icon from '@/components/_atoms/Icon.vue';
import Dialog from '@/components/_atoms/Dialog.vue';

export default {
  name: 'LabelDialog',
  components: { Label, Icon, Dialog },
  model: { prop: 'isShow', event: 'input' },
  props: {
    isShow: { type: Boolean, required: true },
    persistent: { type: Boolean, required: false, default: false },
    width: { type: [String, Number], required: false, default: 600 },
    height: { type: [String, Number], required: false, default: 300 },
    contentMinHeight: { type: [String, Number], required: false, default: 160 },
    warning: { type: Boolean, required: false, default: false },
    error: { type: Boolean, required: false, default: false },
    icon: { type: Boolean, required: false, default: true },
    messagePreWrap: { type: Boolean, required: false, default: true },
    isCloseConfirm: { type: Boolean, required: false, default: false }
  },
  computed: {
    isShowDialog: {
      get() {
        return this.isShow;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    color: {
      get() {
        if (this.warning) {
          // yellow は warning.light（面向けの淡色）なのでアイコンには薄すぎる
          return 'warning';
        }
        return this.error ? 'red' : 'blue';
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.dialog-message {
  max-width: 470px;
}
</style>
